function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 6c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1s1 .448 1 1v4C26 5.552 25.552 6 25 6zM34 14.041H16c-.575 0-1.041-.466-1.041-1.041s.466-1.041 1.041-1.041h18c.575 0 1.041.466 1.041 1.041S34.575 14.041 34 14.041zM44 34H6c-.552 0-1-.447-1-1v-3.7c0-.414.255-.784.642-.934l19-7.3c.23-.089.486-.089.717 0l19 7.3C44.745 28.516 45 28.886 45 29.3V33C45 33.553 44.553 34 44 34z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30 20.9L30 13 28 13 28 20.2zM34 22.5L34 13 32 13 32 21.7zM18 21.7L18 13 16 13 16 22.5zM22 20.2L22 13 20 13 20 20.9zM25 19L26 19.4 26 13 24 13 24 19.4zM7 36v13c0 .553.448 1 1 1h11.3c.552 0 1-.447 1-1v-5.4c0-2.338 1.548-4.32 3.691-4.718 1.416-.271 2.849.08 3.934.974 1.063.879 1.675 2.17 1.675 3.545V49c0 .553.447 1 1 1H42c.553 0 1-.447 1-1V36H7zM33.475 10C32.235 6.51 28.909 4 25 4c-3.909 0-7.235 2.51-8.475 6H33.475z"
});

function SvgCityHall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityHall);
export default __webpack_public_path__ + "static/media/city-hall.a8d5ea4c.svg";
export { ForwardRef as ReactComponent };